<form #formControl="ngForm">
  <mat-dialog-content>
    <mat-form-field>
      <mat-select placeholder="Field" [(ngModel)]="selectedField" name="selectedfields" #selectedfields required multiple>
        <div>
          <div>
            <a (click)="closeOption()" style="float: right">
              <mat-icon>close</mat-icon>
            </a>
          </div>
          <div style="width: 99%; height: 250px; overflow: scroll">
            @for (item of fieldList; track item) {
            <mat-option [value]="item">
              {{ item['name'] }}
            </mat-option>
            }
          </div>
        </div>
      </mat-select>
    </mat-form-field>

    <!-- <mat-form-field color="accent">
    <input matInput #input placeholder="Label" [(ngModel)]='fieldLabel' name="field" required>
  </mat-form-field> -->
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button [disabled]="!formControl.valid" [mat-dialog-close]="1" (click)="confirmAdd()">Add</button>
    <button mat-button (click)="onNoClick()" tabindex="-1">Cancel</button>
  </mat-dialog-actions>
</form>
